import util from '@bmp-vue/core/api/util'

const controller = 'Empresa'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetCustomJSON: function (codigo) {
    return util.Axios.Get(controller + '/GetCustomJSON', codigo)
  },
  PutCustomJSON: function (id, dto) {
    return util.Axios.Put(controller + '/PutCustomJSON', id, dto)
  },
  DownloadImagens: function (id) {
    return util.Axios.GetBlob(controller + '/DownloadImagens/' + id)
  },
  GetAllByCodigoPortal: function (codigoPortal) {
    return util.Axios.Get(controller + '/GetAllByCodigoPortal/' + codigoPortal)
  }
})
